import React, { useState, useEffect } from "react";
import { Autocomplete, TextField, Box, IconButton } from "@mui/material";
import CachedIcon from "@mui/icons-material/Cached";
import LinkIcon from "@mui/icons-material/Link";
import { UseCountry } from "./UseCountry";

export default function LicenceAutocomplete(props) {
  const { getAllCountryList } = UseCountry();
  const [productCountryRes, setProductCountryRes] = useState();
  const [selectedLicenceCountry, setSelectedLicenceCountry] = useState();

  useEffect(() => {
    getAllCountryList((countries) => {
      setProductCountryRes(countries);
    });
  }, []);

  useEffect(() => {
    if (productCountryRes && props.selectedLicenceID) {
      setSelectedLicenceCountry(
        productCountryRes.countries.find((m) => m.id == props.selectedLicenceID)
      );
    }
  }, [productCountryRes, props.selectedLicenceID]);

  useEffect(() => {
    if (selectedLicenceCountry) {
      props.setter({
        ...props.lvl1State,
        licenceCountryID: selectedLicenceCountry.id,
      });
    }
  }, [selectedLicenceCountry]);

  return productCountryRes ? (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Autocomplete
        disablePortal
        id="combo-box-demo"
        value={selectedLicenceCountry ? selectedLicenceCountry : ""}
        options={productCountryRes.countries ? productCountryRes.countries : []}
        getOptionLabel={(countries) =>
          countries.faName ? countries.faName : ""
        }
        isOptionEqualToValue={(option, value) => option.value === value.value}
        renderInput={(params) => (
          <TextField error={props.validation} {...params} label="تحت لیسانس" />
        )}
        renderOption={(props, option) => {
          return (
            <li {...props} key={option.id}>
              {option.faName ? option.faName : ""}
            </li>
          );
        }}
        onChange={(evt, newValue) => {
          if (newValue) {
            setSelectedLicenceCountry(newValue);
          } else {
            setSelectedLicenceCountry();
            props.setter({
              ...props.lvl1State,
              licenceCountryID: 0,
            });
          }
        }}
        fullWidth
        size="small"
      />
      <IconButton
        sx={{ p: 0, m: 1 }}
        onClick={() => {
          getAllCountryList((countries) => {
            setProductCountryRes(countries);
          });
        }}
      >
        <CachedIcon fontSize="small" />
      </IconButton>
      <IconButton sx={{ p: 0 }} href="/Countries" target="_blank">
        <LinkIcon fontSize="small" />
      </IconButton>
    </Box>
  ) : (
    ""
  );
}
